import AssetActions from "../../actions/AssetActions";
import { getTargetArea, getAreaOnlyOffset } from "@/utils/DnDUtils";

export const assetPanelDrop =
  ({ folder_id = null }) =>
  ({ files = [] }) => {
    AssetActions.uploadFiles({ files, folder_id });
  };

export const galleryAssetListContainerDrop = (dragItem) => {
  return {
    data: {
      item: dragItem,
      target: { index: null },
    },
  };
};

export const galleryAssetPanelDrop =
  ({ dropRef, index }) =>
  (dragItem, monitor) => {
    const area = getTargetArea(monitor, dropRef);
    // area-only offset; onReorderList handles dragIndex adjustment
    const targetIndex = index + getAreaOnlyOffset(area);
    const data = {
      item: dragItem,
      target: { index: targetIndex, dropArea: area },
    };

    return { data };
  };
